import React, { useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Box,
  Typography,
} from "@mui/material";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";

function CreateStockDialog({ open, onClose, itemList, onSave, openSnackbar }) {
  const [formData, setFormData] = useState({
    item_id: "",
    item_code: "",
    item_name: "",
    material_grouping: "",
    car_type: "",
    spec: "",
    required_date: dayjs(),
    required_quantity: 0,
  });

  const handleItemChange = (event) => {
    const selectedItem = itemList.find(
      (item) => item.item_id === event.target.value
    );
    
    if (selectedItem) {
      setFormData({
        ...formData,
        item_id: selectedItem.item_id,
        item_code: selectedItem.item_code,
        item_name: selectedItem.item_name,
        material_grouping: selectedItem.material_grouping,
        car_type: selectedItem.car_type,
        spec: selectedItem.spec,
      });
    }
  };

  const handleSave = () => {
    // 유효성 검사
    if (!formData.item_id) {
      openSnackbar("제품을 선택해주세요.", "warning");
      return;
    }

    if (!formData.required_date) {
      openSnackbar("필요 일자를 입력해주세요.", "warning");
      return;
    }

    if (formData.required_quantity <= 0) {
      openSnackbar("필요 수량은 0보다 커야 합니다.", "warning");
      return;
    }

    onSave(formData);
  };

  const handleClose = () => {
    // 폼 초기화
    setFormData({
      item_id: "",
      item_code: "",
      item_name: "",
      material_grouping: "",
      car_type: "",
      spec: "",
      required_date: dayjs(),
      required_quantity: 0,
    });
    onClose();
  };

  return (
    <Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth>
      <DialogTitle>재고 정보 추가</DialogTitle>
      <DialogContent>
        <Box sx={{ display: "flex", flexDirection: "column", gap: 2, mt: 1 }}>
          {/* 제품 선택 */}
          <FormControl fullWidth>
            <InputLabel>고객사 품번</InputLabel>
            <Select
              value={formData.item_id}
              onChange={handleItemChange}
              label="고객사 품번"
            >
              {itemList
                .filter((item) => item.item_type === 1) // ✅ item_type이 1인 것만
                .map((item) => (
                  <MenuItem key={item.item_id} value={item.item_id}>
                    {item.item_code} - {item.material_grouping}
                  </MenuItem>
                ))}
            </Select>
          </FormControl>

          {/* 선택된 제품 정보 표시 */}
          {formData.item_id && (
            <Box
              sx={{
                p: 2,
                bgcolor: "#f5f5f5",
                borderRadius: 1,
                display: "flex",
                flexDirection: "column",
                gap: 0.5,
              }}
            >
              <Typography variant="body2" color="text.secondary">
                <strong>사내 품명:</strong> {formData.material_grouping}
              </Typography>
              <Typography variant="body2" color="text.secondary">
                <strong>차종:</strong> {formData.car_type}
              </Typography>
              <Typography variant="body2" color="text.secondary">
                <strong>규격:</strong> {formData.spec}
              </Typography>
            </Box>
          )}

          {/* 필요 일자 */}
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DatePicker
              label="필요 일자"
              value={formData.required_date}
              onChange={(newValue) =>
                setFormData({ ...formData, required_date: newValue })
              }
              format="YYYY-MM-DD"
              slotProps={{
                textField: {
                  fullWidth: true,
                },
              }}
            />
          </LocalizationProvider>

          {/* 필요 수량 */}
          <TextField
            fullWidth
            label="필요 수량"
            type="number"
            value={formData.required_quantity}
            onChange={(e) =>
              setFormData({
                ...formData,
                required_quantity: parseInt(e.target.value) || 0,
              })
            }
            InputProps={{ inputProps: { min: 0 } }}
          />
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose}>취소</Button>
        <Button
          onClick={handleSave}
          variant="contained"
          color="primary"
          disabled={
            !formData.item_id ||
            !formData.required_date ||
            formData.required_quantity <= 0
          }
        >
          추가
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default CreateStockDialog;
